import { PLATFORM } from 'aurelia-pal';

import { SESSION_EVENTS } from 'libs/oal/constants/sessionEvents.constant';
import { AppConfiguration } from 'libs/oal/services/appConfiguration.service';
import { AppErrorHandler } from 'libs/oal/services/appErrorHandler.service';
import { AppLogger } from 'libs/oal/services/appLogger.service';
import { AppRequestsStorage } from 'libs/oal/services/appRequestsStorage.service';
import { AppRouting } from 'libs/oal/services/appRouting.service';
import { AppSession } from 'libs/oal/services/appSession.service';
import { AppSessionCapabilities } from 'libs/oal/services/appSessionCapabilities.service';
import { AppUtils } from 'libs/oal/services/appUtils.service';
import { AppRoutingStep } from 'libs/oal/steps/appRouting.step';

const menuContainer = PLATFORM.moduleName('libs/oal/containers/menu/menu.container');
/**
 * Registers all the OAL's services and containers the app needs access to.
 * @param {Aurelia} aurelia               The application information.
 * @param {Object}  options               Custom options to configure the plugin/module.
 * @param {Object}  options.configuration The app settings the plugin will send to the
 *                                        `appConfiguration` service.
 */
export const configure = (aurelia, options) => {
  // Constants
  aurelia.container.registerInstance('SESSION_EVENTS', SESSION_EVENTS);

  // Services
  aurelia.container.registerSingleton('appConfiguration', AppConfiguration);
  aurelia.container.registerSingleton('appErrorHandler', AppErrorHandler);
  aurelia.container.registerSingleton('appLogger', AppLogger);
  aurelia.container.registerSingleton('appRequestsStorage', AppRequestsStorage);
  aurelia.container.registerSingleton('appRouting', AppRouting);
  aurelia.container.registerSingleton('appSession', AppSession);
  aurelia.container.registerSingleton('appSessionCapabilities', AppSessionCapabilities);
  aurelia.container.registerSingleton('appUtils', AppUtils);

  // Steps
  aurelia.container.registerInstance('appRoutingStep', AppRoutingStep);

  // Resources
  aurelia.globalResources(menuContainer);

  // Configuration setup
  const appConfiguration = aurelia.container.get('appConfiguration');
  appConfiguration.setConfig(options.configuration);
};
